<div class="xp-dialog-header__text">
	<h2 class="xp-dialog-header__title" [id]="headingId">{{ heading() }}</h2>
	<div *ngIf="subheading()" class="xp-dialog-header__subheading">{{ subheading() }}</div>
</div>
<button mat-icon-button
        type="button"
        class="xp-dialog-header__close"
        [attr.aria-label]="closeLabel()"
        (click)="closeClick.emit()">
	<mat-icon class="xp-dialog-header__close-icon">close</mat-icon>
</button>
